export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  INBOX_QR_UPDATED: 'INBOX_QR_UPDATED',
  INBOX_CONNECTED: 'INBOX_CONNECTED',
  INBOX_DISCONNECTED: 'INBOX_DISCONNECTED',
  INBOX_RECONNECTED: 'INBOX_RECONNECTED',
  QR_MODAL_OPENED: 'QR_MODAL_OPENED',
  QR_MODAL_CLOSED: 'QR_MODAL_CLOSED',
  LEAD_MESSAGE_NOTIFICATION: 'LEAD_MESSAGE_NOTIFICATION',
  PIPELINE_BOARD_SYNC_REQUESTED: 'PIPELINE_BOARD_SYNC_REQUESTED',
  PIPELINE_REPLY_STATE_UPDATED: 'PIPELINE_REPLY_STATE_UPDATED',
};
